import { render, staticRenderFns } from "./clinic-doctor-detailed-consultation-guide.vue?vue&type=template&id=5f8a9236&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports